import React from "react";
import PropTypes from 'prop-types';
import Layout from "./../../global/Layout";
import { StyledContainer, StyledH2 } from "./styles";
import { toggleClientRoot } from "./../toggleClientRoute";

// Default server side - we will feed this to Storybook & set up Typescript.
export const NotFound = ({ context, clientContext }) => {
  toggleClientRoot();
  let { isMobile } = clientContext;
  if (isMobile === true) {
    return (
      <Layout context={context} clientContext={clientContext}>
        <StyledContainer>
          <StyledH2>NotFound</StyledH2>
        </StyledContainer>
      </Layout>
    );
  } else {
    return (
      <Layout context={context} clientContext={clientContext}>
        <StyledContainer>
          <StyledH2>NotFound</StyledH2>
        </StyledContainer>
      </Layout>
    );
  }
};

NotFound.propTypes = {
  /**
   Client side variables
  */
  clientContext: PropTypes.object,
  /**
   Server side variables
  */
  context: PropTypes.object.isRequired,
};
